import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Response } from '../../shared/models/response.model';
import { Région } from './model/région.model';

@Injectable({
  providedIn: 'root',
})
export class RégionService {
  #http = inject(HttpClient);

  readonly BASE_URL = '/régions';

  trouverTous = (idCartographie: string) => {
    return this.#http.get<Response<Région>>(this.BASE_URL, { params: { idCartographie } });
  };
}
